import state from './state'

/**
 * The Vuex `getXxx` prefix is dropped now these are read as `ui.store.getters.notifications`, the
 * same way the `system` module's were.
 */
export default {
  get notifications () {
    return state().notifications
  },

  get unreadMessageCount () {
    return state().unreadMessageCount
  },

  get unreadNotificationCount () {
    return state().unreadNotificationCount
  },

  get redirectData () {
    return state().redirect
  },

  get triggerLoginNotification () {
    return state().triggerLoginNotification
  },

  get loginForwardUrl () {
    return state().loginForwardUrl
  },

  get showMessageDialog () {
    return state().showMessageDialog
  },

  get userStats () {
    return state().userStats
  },

  get isReadyToRender () {
    return state().isReadyToRender
  },

  get lastError () {
    return state().lastError
  }
}
